import { render, staticRenderFns } from "./DriveGoalsModal.vue?vue&type=template&id=6547a52b&scoped=true"
import script from "./DriveGoalsModal.vue?vue&type=script&lang=js"
export * from "./DriveGoalsModal.vue?vue&type=script&lang=js"
import style0 from "./DriveGoalsModal.vue?vue&type=style&index=0&id=6547a52b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6547a52b",
  null
  
)

export default component.exports